howspace.mediaShare = (() => {
    'use strict';

    const isValidTimeFormat = (timeStr) => {
        const timeValue = String(timeStr ?? '').trim();
        if (!timeValue) return false;


        if (!/^\d+(?::\d+){0,2}$/.test(timeValue)) return false;

        const parts = timeValue.split(':').map(Number);
        if (parts.length > 3 || parts.some(Number.isNaN)) return false;

        if (parts.length >= 2 && parts[1] > 59) return false;
        if (parts.length === 3 && parts[2] > 59) return false;

        return true;
    };

    const convertToSeconds = (timeStr) => {
        return (String)(timeStr)
            .trim()
            .split(':')
            .map((p) => parseInt(p, 10))
            .reduce((acc, cur) => acc * 60 + cur, 0);
    };

    const getSharedLink = (button) => {
        const seconds = button.data('start-at-seconds') || 0;
        const widgetId = button.data('widget-id');

        const urlObj = new URL(window.location.href.split('#')[0]);
        urlObj.searchParams.delete('start_at');
        let href = urlObj.toString();

        // Remove #widget-... fragment if present
        const cleanHref = href.replace(/#widget-\d+$/, '');

        if (seconds > 0) {
            return `${cleanHref}?start_at=${widgetId}:${seconds}`;
        }
        return `${cleanHref}#widget-${widgetId}`;
    };

    const formatTimeInput = (timeStr) => {
        const raw = String(timeStr ?? '').trim();
        if (!raw) return '';

        const cleaned = raw.replace(/[^0-9:]/g, '');
        if (!isValidTimeFormat(cleaned)) return cleaned;

        const parts = cleaned.split(':').map(n => parseInt(n, 10));

        let totalSeconds = 0;
        for (const p of parts) totalSeconds = totalSeconds * 60 + p;

        if (!Number.isFinite(totalSeconds) || totalSeconds < 0) return cleaned;

        const pad2 = (n) => String(n).padStart(2, '0');

        const hh = Math.floor(totalSeconds / 3600);
        const mm = Math.floor((totalSeconds % 3600) / 60);
        const ss = totalSeconds % 60;

        if (hh > 0) {
            return `${hh}:${pad2(mm)}:${pad2(ss)}`;
        }
        return `${mm}:${pad2(ss)}`;
    };

    /**
     * Scrolls to the widget, seeks the player to the timestamp from ?start_at, and
     * (for video) updates the start-at-info label. Does not trigger playback — call
     * triggerVideoPlayback() with the returned targetPlayer for that.
     *
     * @param {URLSearchParams} urlParams
     * @returns {{ handled: boolean, targetPlayer: jQuery|null }}
     */
    const handleSharingMomentFromParams = (urlParams) => {
        const startAt = urlParams.get('start_at');
        if (!startAt) return;

        const parts = startAt.split(':');
        if (parts.length !== 2) return {
            handled: false,
            targetPlayer: null
        };

        const widgetId = parts[0];
        const secPos = Number(parts[1]) || 0;

        const widget = $('#widget-' + widgetId);
        if (!widget.length) return {
            handled: false,
            targetPlayer: null
        };

        howspace.scroller.scrollToElement(widget);

        let targetPlayer = null;
        let startAtMsg = '';
        if (widget.is('.widget-audio')) {
            targetPlayer = widget.find('.howspace-audio-player');
        } else if (widget.is('.widget-video')) {
            targetPlayer = widget.find('.howspace-video-player');
            startAtMsg = howspace.translate('videoplayer_playback_start_at', {
                time: formatTimeInput(secPos)
            });
        }

        if (targetPlayer && targetPlayer.length > 0) {
            const isPlaying = targetPlayer.is('.playing');

            if (!isPlaying) {
                targetPlayer.dataAndAttr('start-at-seconds', secPos);
                if (targetPlayer.find('.start-at-info').length > 0) {
                    targetPlayer.find('.start-at-info').removeClass('d-none').text(startAtMsg);
                }
            } else {
                const vjs = videojs(targetPlayer.find('.video-js')[0]);
                vjs.currentTime(secPos);
            }
        }

        return {
            handled: true,
            targetPlayer: targetPlayer
        }
    };

    /**
     * Triggers playback on a video player element after seeking.
     */
    const triggerVideoPlayback = (targetPlayer) => {
        if (!targetPlayer || targetPlayer.length === 0 || targetPlayer.is('.howspace-audio-player')) {
            return;
        }
        setTimeout(() => {
            if (!targetPlayer.is('.has-started')) {
                targetPlayer.find('.play-button').trigger('click');
            } else {
                const vjs = videojs(targetPlayer.find('.video-js')[0]);
                vjs.play();
            }
        }, 500);
    };

    const handleSharingMomentLink = () => {
        const urlParams = new URLSearchParams(window.location.search);
        handleSharingMomentFromParams(urlParams);

        real.dom.$body.on('click', 'a.sharing-moment-link', e => {
            const link = $(e.currentTarget);
            const href = link.attr('href');
            const urlParams = new URLSearchParams(new URL(href, window.location.href).search);

            const { handled, targetPlayer } = handleSharingMomentFromParams(urlParams);
            if (handled) {
                // Remove the start_at param from the URL without reloading the page.
                const urlObj = new URL(window.location.href);
                urlObj.searchParams.delete('start_at');
                window.history.replaceState({}, document.title, urlObj.toString());

                triggerVideoPlayback(targetPlayer);
                e.preventDefault();
            }
        });
    };

    return {
        getSharedLink,
        formatTimeInput,
        handleSharingMomentLink,
        handleSharingMomentFromParams,
        triggerVideoPlayback,
    };

})();
